<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-04-29 16:17:39
 * @LastEditors: luckymiaow
-->

<script lang="ts" setup>
import { onMounted, useAttrs, useSlots, watch } from 'vue';
import type { valueType } from 'ant-design-vue/lib/statistic/utils';
import { UnitType } from '../types';
import type { IInputMoneyProps } from '../types';
// import { InputNumber as AInputNumber } from 'ant-design-vue';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';
import useSlot from '../../hooks/useSlot';
import { InputNumber } from '../../input-number/';

// TODO 实际值 ->分  显示 -> 根据外部传的值

const props = withDefaults(defineProps<IProps>(), {
  unit: UnitType.万,
  showUnit: false,
  unitText: undefined,
  step: 0.1,
});

interface IProps extends IInputMoneyProps {
  unit?: UnitType; // 转换单位
  showUnit?: boolean; // 是否显示单位
  unitText?: string | null; // 显示单位
  step?: number; // 精度
}

let unitDot = '';

// formatter=>getViewText；指定输入框展示值的格式
function getViewText(value: valueType) {
  // console.log('%c [getViewText-- value ]-49', 'font-size:13px; background:pink; color:#bf2c9f;', value);
  let res = '';
  // console.log('%c [getViewText-- props.unit ]-57', 'font-size:13px; background:pink; color:#bf2c9f;', props.unit);
  if (String(value)[String(value).length - 1] == '.') {
    value = `${Number(value) / props.unit}.`;
  } else {
    value = Number(value) / props.unit;
  }
  res = `${value}${unitDot}`;
  // console.log('%c [ res ]-58', 'font-size:13px; background:pink; color:#bf2c9f;', res);
  return res;
}

// parser指定从 formatter 里转换回数字的方式
function parserT(value: string | number) {
  // console.log('%c [ parserT--value ]-68', 'font-size:13px; background:pink; color:#bf2c9f;', value);
  // console.log('%c [parserT-- props.unit  ]-72', 'font-size:13px; background:pink; color:#bf2c9f;', props.unit);
  value = String(value).replace(unitDot, '');
  if (value[value.length - 1] == '.') {
    return `${Number(value) * props.unit}.`;
  }
  let res = 0;
  if (!(Number(value) >= 0)) value = 0;
  res = Number(value) * props.unit;
  // console.log('%c [parserT-- res--parser ]-72', 'font-size:13px; background:pink; color:#bf2c9f;', res);
  return res;
}

watch(
  () => props.unit,
  val => {
    console.log('%c [ val ]-93', 'font-size:13px; background:pink; color:#bf2c9f;', val);
  }
);

onMounted(() => {
  if (props.unitText) unitDot = props.unitText;
  else if (props.showUnit) unitDot = UnitType[props.unit];
});

const { getBindValue } = useForm<IProps>({ props, componentName: 'inputMoney', attrs: useAttrs() });

const { useExcludeSlots } = useSlot({ slots: useSlots() }, ['iconRender', 'default']);
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <span
    v-if="getBindValue?.readOnly && readOnlySlot in $slots"
    :class="getBindValue?.readOnlyClassName"
    :style="getBindValue?.readOnlyStyle ? getBindValue?.readOnlyStyle : {}"
    ><slot :name="readOnlySlot" :text="value"></slot
  ></span>

  <InputNumber v-else v-bind="getBindValue" :formatter="getViewText" :parser="parserT">
    <template v-for="(slot, key) in useExcludeSlots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </InputNumber>

  <!-- <span> 转换的单位-- {{ unit }} </span> -->
</template>
